import gql from 'graphql-tag';

export class EidEasyQueries {
  static getEidEasyDoc = gql`
    query getEidEasyDoc {
      getEidEasyDoc {
        eidEasyDocId
        expiresAt
      }
    }
  `;
}
